<script setup>
    import { ref, onMounted } from 'vue';
    import Modal from '@/components/modals/Modal.vue';
    import { getTopIndustries, getEvalTags, setTopIndustries } from '../services/leaderboardService';
    import { useLayoutComponents } from '@/composables/layout';
    import { useToast } from '@/composables/use-toast';
    const { MultiSelect, TextInput, PrimaryButton } = useLayoutComponents();
    const { addToast } = useToast();

    const props = defineProps({
        show: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits(['close']);
    const evalTagsOptions = ref([]);
    const selectedIndustries = ref([]);
    const topNumber = ref(0);

    const loadTopIndustries = async () => {
        const data = await getTopIndustries();
        selectedIndustries.value = data.typeIds.map(id => String(id));
        topNumber.value = data.topNumber;
    }

    const setEvalTags = async () => {
        const data = await getEvalTags();
        data.forEach(tag => {
            evalTagsOptions.value.push({
                label: tag.type,
                value: tag.id
            });
        });
    }

    const saveTopIndustries = async () => {
        try {
            const data = await setTopIndustries(selectedIndustries.value, topNumber.value);
            if(data) {
                addToast('Top industries saved successfully', 'success');
                emit('close');
            } else {
                addToast('Failed to save top industries', 'error');
            }
        } catch (error) {
            addToast(error.message, 'error');
        }
    }

    onMounted(async () => {
        await loadTopIndustries();
        await setEvalTags();
    });
</script>
<template>
    <Modal :isOpen="show" @close="emit('close')" title="Top Industries" size="lg">
        <div class="text-white/80 mb-4 bg-white/10 p-4 rounded-lg flex items-center gap-2">
            <div>
                <i class="uil uil-info-circle text-2xl text-white"></i>
            </div>
            <div class="text-xs font-medium">
                Define the top industries that will be displayed in the landing page leaderboard and the top number llms will be displayed for each industry.
            </div>
        </div>
        <div class="grid grid-cols-6 gap-4">
            <div class="col-span-4">
                <label for="industries" class="block text-white/80 text-sm font-medium mb-2 flex items-center gap-2">Industries</label>
                <MultiSelect v-model="selectedIndustries" :options="evalTagsOptions" option-label="label" option-value="value" placeholder="Select industries" />
            </div>
            <div class="col-span-2">
                <label for="topNumber" class="block text-white/80 text-sm font-medium mb-2">Top Number</label>
                <TextInput v-model="topNumber" type="number" placeholder="Enter top number" min="1" max="10" />
            </div>
        </div>
        <div class="flex justify-end mt-6">
            <PrimaryButton @click="saveTopIndustries">
                Save
            </PrimaryButton>
        </div>
    </Modal>
</template>
